module.exports = __webpack_public_path__ + "img/subscription_choose.354e2bae.png";